import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, TrendingUp } from 'lucide-react';

export function SectionHeading({ kicker, title, subtitle, right }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
      <div>
        <div className="kicker text-copper-600 mb-3 flex items-center gap-2">
          <span className="h-px w-8 bg-copper-500 inline-block" />
          {kicker}
        </div>
        {title && <h2 className="font-serif text-[36px] md:text-[44px] tracking-tight text-ink-800 leading-[1.05]">{title}</h2>}
        {subtitle && <p className="mt-3 text-[15px] text-ink-500 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
      {right && <div>{right}</div>}
    </div>
  );
}

export default function DatasetCards({ datasets = [], loading = false }) {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24">
      <SectionHeading
        kicker="What we track"
        title={<>Seven datasets, <span className="italic font-light">one ledger.</span></>}
        subtitle="Each card opens to a complete record with sources, methodology and 8-quarter trend lines. Updated as the source publishes."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {(loading && datasets.length === 0 ? Array.from({ length: 7 }) : datasets).map((d, i) => (
          d ? (
            <Link
              key={d.key}
              to={d.href}
              className="group relative block bg-cream-50 border border-ink-300/60 rounded-sm p-7 lift"
            >
              <div className="flex items-center justify-between mb-7">
                <span className="kicker text-ink-500">{d.label}</span>
                <ArrowUpRight size={16} className="text-ink-500 group-hover:text-copper-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition" />
              </div>
              <div className="font-serif text-[34px] tracking-tight text-ink-800 leading-tight tabular">
                {d.value}
              </div>
              <div className="mt-3 text-[13px] text-ink-500 leading-relaxed min-h-[40px]">{d.sub}</div>
              <div className="mt-6 pt-5 border-t border-ink-300/50 flex items-center gap-2 text-[11px] uppercase tracking-wider text-ink-500">
                <TrendingUp size={11} className="text-copper-500" />
                <span className="truncate">View dataset</span>
              </div>
            </Link>
          ) : (
            <div key={i} className="bg-cream-50 border border-ink-300/60 rounded-sm p-7 animate-pulse">
              <div className="h-3 w-20 bg-ink-200 mb-7" />
              <div className="h-9 w-36 bg-ink-200 mb-3" />
              <div className="h-3 w-44 bg-ink-200" />
            </div>
          )
        ))}
      </div>
    </section>
  );
}
